import { AttachType, MessageReplyToModel } from '$store/models';
import { formatCurrency } from '$utils';

type Translator = (key: string, params?: any) => string;

export const SCROLL_TO_MESSAGE_EVENT = 'chat_scroll_to_message';

export function scrollToChatMessage(messageId: number) {
  window.dispatchEvent(new CustomEvent(SCROLL_TO_MESSAGE_EVENT, { detail: messageId }));
}

export interface ReplyPreview {
  text: string;
  imageUrl?: string;
}

export function getReplyPreview(
  replyTo: MessageReplyToModel,
  t: Translator,
): ReplyPreview {
  if (replyTo.isDeleted) {
    return { text: t('message_reply_deleted', { defaultValue: 'Deleted message' }) };
  }

  const attach = replyTo.attachments?.[0];
  let label = '';
  let imageUrl: string | undefined;

  if (attach) {
    switch (attach.type) {
      case AttachType.PHOTO:
        label = t('dialog_attach_photo');
        if (!attach.photo?.encrypted) {
          imageUrl = attach.photo?.thumbnail || attach.photo?.photoMedium;
        }
        break;
      case AttachType.VIDEO:
        label = t('dialog_attach_video');
        if (!attach.video?.encrypted) {
          imageUrl = attach.video?.thumbnail || attach.video?.photoMedium;
        }
        break;
      case AttachType.TIPS:
        label = attach.tips
          ? `${t('dialog_attach_tips')}, ${formatCurrency(
              attach.tips.amount,
              attach.tips.currency,
            )}`
          : t('dialog_attach_tips');
        break;
      case AttachType.GIFT:
        label = t('dialog_attach_gift');
        break;
      case AttachType.VALENTINE_DAY_STICKER:
        label = t('dialog_attach_valentine_day_sticker');
        break;
      default:
        label = t('message_reply_media', { defaultValue: 'Media' });
    }
  }

  const text =
    replyTo.text || label || t('message_paid_label', { defaultValue: 'Paid message' });

  return { text, imageUrl };
}
